import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

type GenerateIconComponentType = (icon: IconDefinition) => (props: Partial<FontAwesomeIconProps>) => JSX.Element;

export const generateIconComponent: GenerateIconComponentType =
  (icon) =>
    ({ size, ...rest }) =>
      <FontAwesomeIcon icon={icon} size={size || 'lg'} fill="currentColor" {...rest} />;
